import { writable } from "svelte/store";

// The seasonal campaign the page is showing (lib/campaign.js), or null.
// +layout.svelte sets it from the server's answer first, so hydration matches
// the HTML, then again from the visitor's clock on mount.
export const campaign = writable(null);
